<div class="item-manager-compact">
  <label for="product-search" class="field-label">
    Order Items<span *ngIf="required" class="required">*</span>
  </label>

  <!-- Product Search Section -->
  <div class="add-product-section">
    <p-autoComplete
      inputId="product-search"
      [(ngModel)]="selectedProduct"
      [suggestions]="filteredProducts"
      (completeMethod)="search($event)"
      (onSelect)="onProductSelect($event)"
      (onFocus)="onProductFocus()"
      [disabled]="disabled"
      [minLength]="0"
      placeholder="Search and add products..."
      styleClass="w-full"
      [dropdown]="true"
      [forceSelection]="false"
      [showClear]="true"
      field="Title"
      appendTo="body"
    >
      <ng-template let-product pTemplate="item">
        <div class="product-item-wrapper">
          <div class="product-item-details">
            <div class="product-title-row">
              {{ product.Title }}
              <span class="product-sku" *ngIf="product.Sku">{{
                product.Sku
              }}</span>
            </div>
          </div>
          <div class="product-price">${{ product.Price?.toFixed(2) }}</div>
        </div>
      </ng-template>
    </p-autoComplete>
    <small class="text-gray-500 block mt-1">
      Click dropdown or type at least 2 characters to search
    </small>
  </div>

  <!-- Disabled Items Section (matches old QMC lines 387-460) -->
  <div *ngIf="getDisabledItems().length > 0" class="disabled-items-section">
    <h4 class="section-title disabled-title">
      <i class="pi pi-exclamation-triangle"></i>
      Disabled Items
      <i
        class="pi pi-info-circle info-icon"
        pTooltip="Scheduled Order Items are disabled due to being Out of Stock, Not Enabled for Processing, Inactive, and/or Invalid."
        tooltipPosition="right"
      ></i>
    </h4>
    <p class="section-subtitle">These items are disabled for processing</p>

    <p-table
      [value]="getDisabledItems()"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="compact-table disabled-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <!-- Status Icon column -->
          <th style="width: 50px"></th>
          <th style="min-width: 250px; width: 45%">Product</th>
          <th style="width: 110px">Quantity</th>
          <th style="width: 110px">Price</th>
          <th style="width: 110px">Sale</th>
          <th style="width: 100px" class="text-right">Total</th>
          <!-- Actions column -->
          <th style="width: 50px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-itemControl let-rowIndex="rowIndex">
        <tr class="disabled-item-row">
          <!-- Status Icon with Tooltip (matches old QMC lines 404, 413, 421, 430, 446) -->
          <td class="text-center">
            <i
              [class]="'pi ' + getDisabledIcon(itemControl.value)"
              [pTooltip]="getDisabledReason(itemControl.value)"
              tooltipPosition="right"
              class="disabled-icon"
            ></i>
          </td>

          <!-- Product -->
          <td>
            <div class="product-info disabled">
              <div class="product-name">
                {{
                  itemControl.value.product?.Title ||
                    itemControl.value.product?.Name ||
                    "Unknown Product"
                }}
              </div>
              <div class="product-sku">
                ID: {{ itemControl.value.productId }}
              </div>
            </div>
          </td>

          <!-- Quantity (Read-only) -->
          <td>
            <span class="disabled-value">{{ itemControl.value.quantity }}</span>
            <!-- Stock indicator for disabled items -->
            <div class="stock-indicator">
              <span
                class="stock-tag"
                [class.in-stock]="
                  itemControl.value.product?.Stock === -1 ||
                  (itemControl.value.product?.Stock !== undefined &&
                    itemControl.value.product?.Stock !== null &&
                    itemControl.value.product?.Stock > 0)
                "
                [class.out-of-stock]="itemControl.value.product?.Stock === 0"
                [class.undefined-stock]="
                  itemControl.value.product?.Stock === undefined ||
                  itemControl.value.product?.Stock === null
                "
              >
                <ng-container *ngIf="itemControl.value.product?.Stock === -1">
                  <i class="pi pi-check-circle"></i> In Stock: -1
                </ng-container>
                <ng-container *ngIf="itemControl.value.product?.Stock === 0">
                  <i class="pi pi-exclamation-circle"></i> Out of Stock: 0
                </ng-container>
                <ng-container
                  *ngIf="
                    itemControl.value.product?.Stock !== undefined &&
                    itemControl.value.product?.Stock !== null &&
                    itemControl.value.product?.Stock > 0
                  "
                >
                  <i class="pi pi-info-circle"></i> Stock:
                  {{ itemControl.value.product.Stock }}
                </ng-container>
                <ng-container
                  *ngIf="
                    itemControl.value.product?.Stock === undefined ||
                    itemControl.value.product?.Stock === null
                  "
                >
                  <i class="pi pi-question-circle"></i> Stock: N/A
                </ng-container>
              </span>
            </div>
          </td>

          <!-- Price (Read-only) -->
          <td>
            <span class="disabled-value"
              >${{ itemControl.value.price?.toFixed(2) || "0.00" }}</span
            >
          </td>

          <!-- Sale Price (Read-only) -->
          <td>
            <span class="disabled-value">{{
              itemControl.value.salePrice
                ? "$" + itemControl.value.salePrice.toFixed(2)
                : "—"
            }}</span>
          </td>

          <!-- Total (Read-only) -->
          <td class="text-right">
            <span class="disabled-value"
              >${{
                (
                  (itemControl.value.quantity || 0) *
                  (itemControl.value.salePrice || itemControl.value.price || 0)
                ).toFixed(2)
              }}</span
            >
          </td>

          <!-- Actions -->
          <td class="text-center">
            <p-button
              icon="pi pi-trash"
              [text]="true"
              [rounded]="true"
              severity="danger"
              size="small"
              (onClick)="
                removeItem(itemsFormArray.controls.indexOf(itemControl))
              "
              [disabled]="disabled"
              styleClass="compact-action-btn"
              pTooltip="Remove item"
              tooltipPosition="left"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center empty-state">
            <span>No disabled items</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Scheduled Order Items Section (matches old QMC lines 461-510) -->
  <div class="enabled-items-section">
    <h4
      *ngIf="getDisabledItems().length > 0"
      class="section-title enabled-title"
    >
      <i class="pi pi-shopping-cart"></i>
      Scheduled Order Items
    </h4>
    <p *ngIf="getDisabledItems().length > 0" class="section-subtitle">
      These items will be included when the order processes
    </p>

    <p-table
      [value]="getEnabledItems()"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="compact-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <!-- Frozen left: Expand column -->
          <th pFrozenColumn [frozen]="true" style="width: 50px"></th>
          <th style="min-width: 250px; width: 45%">Product</th>
          <th style="width: 110px">Quantity</th>
          <th style="width: 110px">Price</th>
          <th style="width: 110px">Sale</th>
          <th style="width: 100px" class="text-right">Total</th>
          <!-- Frozen right: Actions column -->
          <th
            pFrozenColumn
            [frozen]="true"
            [alignFrozen]="'right'"
            style="width: 50px"
          ></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-itemControl let-rowIndex="rowIndex">
        <tr [ngClass]="{ 'item-disabled': itemControl.value.disabled }">
          <!-- Frozen left: Expand button -->
          <td pFrozenColumn [frozen]="true" class="text-center">
            <button
              type="button"
              class="expand-toggle"
              (click)="toggleRow(itemControl)"
              [pTooltip]="
                isRowExpanded(itemControl)
                  ? 'Hide advanced options'
                  : 'Show advanced options'
              "
            >
              <i
                class="pi"
                [class.pi-chevron-down]="!isRowExpanded(itemControl)"
                [class.pi-chevron-up]="isRowExpanded(itemControl)"
              ></i>
            </button>
          </td>

          <!-- Product -->
          <td>
            <div class="product-info">
              <div class="product-name">
                {{
                  itemControl.value.product?.Title ||
                    itemControl.value.product?.Name ||
                    "Unknown Product"
                }}
              </div>
              <div class="product-sku">
                ID: {{ itemControl.value.productId }}
              </div>
            </div>
          </td>

          <!-- Quantity (Compact) -->
          <td>
            <p-inputNumber
              [formControl]="itemControl.controls.quantity"
              (onInput)="
                onQuantityChange(itemControl, itemControl.value.quantity)
              "
              [disabled]="disabled || itemControl.value.disabled"
              [min]="1"
              [max]="9999"
              [showButtons]="true"
              buttonLayout="horizontal"
              [inputStyle]="{ width: '60px', 'text-align': 'center' }"
              styleClass="compact-number"
              decrementButtonClass="compact-btn"
              incrementButtonClass="compact-btn"
            />
            <!-- Stock indicator -->
            <div class="stock-indicator">
              <span
                class="stock-tag"
                [class.in-stock]="
                  itemControl.value.product?.Stock === -1 ||
                  (itemControl.value.product?.Stock !== undefined &&
                    itemControl.value.product?.Stock !== null &&
                    itemControl.value.product?.Stock > 0)
                "
                [class.low-stock]="
                  itemControl.value.product?.Stock !== undefined &&
                  itemControl.value.product?.Stock !== null &&
                  itemControl.value.product?.Stock > 0 &&
                  itemControl.value.product?.Stock <= 5
                "
                [class.out-of-stock]="itemControl.value.product?.Stock === 0"
                [class.undefined-stock]="
                  itemControl.value.product?.Stock === undefined ||
                  itemControl.value.product?.Stock === null
                "
              >
                <ng-container *ngIf="itemControl.value.product?.Stock === -1">
                  <i class="pi pi-check-circle"></i> In Stock: -1
                </ng-container>
                <ng-container *ngIf="itemControl.value.product?.Stock === 0">
                  <i class="pi pi-exclamation-circle"></i> Out of Stock: 0
                </ng-container>
                <ng-container
                  *ngIf="
                    itemControl.value.product?.Stock !== undefined &&
                    itemControl.value.product?.Stock !== null &&
                    itemControl.value.product?.Stock > 0
                  "
                >
                  <i class="pi pi-info-circle"></i> Stock:
                  {{ itemControl.value.product.Stock }}
                </ng-container>
                <ng-container
                  *ngIf="
                    itemControl.value.product?.Stock === undefined ||
                    itemControl.value.product?.Stock === null
                  "
                >
                  <i class="pi pi-question-circle"></i> Stock: N/A
                </ng-container>
              </span>
            </div>
          </td>

          <!-- Price -->
          <td>
            <p-inputNumber
              [formControl]="itemControl.controls.price"
              (onInput)="onPriceChange(itemControl, itemControl.value.price)"
              [disabled]="disabled || itemControl.value.disabled"
              [min]="0"
              mode="currency"
              currency="USD"
              locale="en-US"
              [inputStyle]="{ width: '90px' }"
              styleClass="compact-number"
            />
          </td>

          <!-- Sale Price -->
          <td>
            <p-inputNumber
              [formControl]="itemControl.controls.salePrice"
              (onInput)="
                onSalePriceChange(itemControl, itemControl.value.salePrice)
              "
              [disabled]="disabled || itemControl.value.disabled"
              [min]="0"
              mode="currency"
              currency="USD"
              locale="en-US"
              [inputStyle]="{ width: '90px' }"
              styleClass="compact-number"
              placeholder="—"
            />
          </td>

          <!-- Total -->
          <td class="text-right">
            <span class="item-total"
              >${{
                (
                  (itemControl.value.quantity || 0) *
                  (itemControl.value.salePrice || itemControl.value.price || 0)
                ).toFixed(2)
              }}</span
            >
          </td>

          <!-- Frozen right: Actions -->
          <td
            pFrozenColumn
            [frozen]="true"
            [alignFrozen]="'right'"
            class="text-center"
          >
            <p-button
              icon="pi pi-trash"
              [text]="true"
              [rounded]="true"
              severity="danger"
              size="small"
              (onClick)="
                removeItem(itemsFormArray.controls.indexOf(itemControl))
              "
              [disabled]="disabled"
              styleClass="compact-action-btn"
              pTooltip="Remove item"
              tooltipPosition="left"
            />
          </td>
        </tr>

        <!-- Expandable Row: Advanced Options -->
        <tr *ngIf="isRowExpanded(itemControl)" class="expanded-row">
          <td colspan="7">
            <div class="advanced-options">
              <div class="options-grid">
                <!-- Cycles -->
                <div class="option-field">
                  <label>Cycles</label>
                  <p-inputNumber
                    [formControl]="itemControl.controls.cycles"
                    (onInput)="
                      onCyclesChange(itemControl, itemControl.value.cycles)
                    "
                    [disabled]="disabled || itemControl.value.disabled"
                    [min]="0"
                    [max]="9999"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    [inputStyle]="{ width: '100%' }"
                    styleClass="compact-number"
                    placeholder="0 = always"
                  />
                </div>

                <!-- Min Cycles -->
                <div class="option-field">
                  <label>Min Cycles</label>
                  <p-inputNumber
                    [formControl]="itemControl.controls.minCycles"
                    (onInput)="
                      onMinCyclesChange(
                        itemControl,
                        itemControl.value.minCycles
                      )
                    "
                    [disabled]="disabled || itemControl.value.disabled"
                    [min]="0"
                    [max]="9999"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    [inputStyle]="{ width: '100%' }"
                    styleClass="compact-number"
                  />
                </div>

                <!-- Max Cycles -->
                <div class="option-field">
                  <label>Max Cycles</label>
                  <p-inputNumber
                    [formControl]="itemControl.controls.maxCycles"
                    (onInput)="
                      onMaxCyclesChange(
                        itemControl,
                        itemControl.value.maxCycles
                      )
                    "
                    [disabled]="disabled || itemControl.value.disabled"
                    [min]="0"
                    [max]="9999"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    [inputStyle]="{ width: '100%' }"
                    styleClass="compact-number"
                  />
                </div>
              </div>

              <div class="options-help">
                <i class="pi pi-info-circle"></i>
                <span
                  >Cycles = how many times this item is included (0 =
                  always)</span
                >
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center empty-state">
            <i class="pi pi-shopping-cart"></i>
            <div class="empty-title">No items in order</div>
            <div class="empty-subtitle">
              Search and add products to get started
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <!-- Items Total (before discount) -->
        <tr class="footer-totals-row">
          <td colspan="7" class="footer-row-content">
            <div class="footer-row-inner">
              <span class="footer-label">Order Items Total:</span>
              <span class="footer-value">
                ${{ getItemsTotalBeforeDiscount().toFixed(2) }}
              </span>
            </div>
          </td>
        </tr>

        <!-- Price Discount (only show if there are sale prices) -->
        <tr *ngIf="getPriceDiscount() !== 0" class="footer-totals-row">
          <td colspan="7" class="footer-row-content">
            <div class="footer-row-inner">
              <span class="footer-label">Price Discount:</span>
              <span class="footer-value discount-value">
                ${{ getPriceDiscount().toFixed(2) }}
              </span>
            </div>
          </td>
        </tr>

        <!-- Final Subtotal -->
        <tr class="subtotal-final-row">
          <td colspan="7" class="footer-row-content">
            <div class="footer-row-inner">
              <span class="footer-label subtotal-label"
                >Order Items Subtotal:</span
              >
              <span class="footer-value subtotal-final-value">
                ${{ getGrandTotal().toFixed(2) }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Validation Message -->
  <small
    *ngIf="required && itemsFormArray.controls.length === 0"
    class="error-text"
  >
    At least one item is required
  </small>

  <!-- Confirm Dialog -->
  <p-confirmDialog />
</div>
